import { render, staticRenderFns } from "./ShippingOrderInfo.vue?vue&type=template&id=54f0f1f0&"
import script from "./ShippingOrderInfo.vue?vue&type=script&lang=js&"
export * from "./ShippingOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports